import React, { useState } from 'react';
import { Button } from './components/default/Button/Button';
import Footer from './components/default/Footer/Footer';
import Navbar from './components/default/Navbar/Navbar';
import Part1 from './components/Part1/Part1';
import Part2 from './components/Part2/Part2';
import Part3 from './components/Part3/Part3';
import Part4 from './components/Part4/Part4';




function App() {

  return (
    <div className="App">

  

      <Navbar/>
      <Part1/>
      <Part2/>
      {/* <Part3/> */}
      <Part4/>
      <Footer/>


    </div>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js